import { useAuth } from '@/features/auth/auth';

export const useOptionalUser = () => {
  const { user } = useAuth();

  return user;
};
